import { NavLink } from "react-router-dom";
import Icon3D from "@/components/base/Icon3D";

interface TabItem {
  to: string;
  label: string;
  icon: string;
  end?: boolean;
}

const tabs: TabItem[] = [
  { to: "/", label: "Inicio", icon: "ri-home-5-fill", end: true },
  { to: "/inventario", label: "Inventario", icon: "ri-box-3-fill" },
  { to: "/movimientos", label: "Movimientos", icon: "ri-exchange-fill" },
  { to: "/documentos", label: "Documentos", icon: "ri-file-text-fill" },
  { to: "/reportes", label: "Reportes", icon: "ri-bar-chart-2-fill" },
];

export default function BottomTabBar() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-background-200/70 bg-background-50/90 backdrop-blur-xl">
      <div className="mx-auto grid max-w-[480px] grid-cols-5 pb-[env(safe-area-inset-bottom)]">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className="flex h-16 flex-col items-center justify-center gap-1"
          >
            {({ isActive }) => (
              <>
                <span
                  className={`flex h-7 w-7 items-center justify-center rounded-full transition-all ${
                    isActive ? "bg-primary-100 scale-110" : "scale-100"
                  }`}
                >
                  <Icon3D
                    icon={tab.icon}
                    tone={isActive ? "primary" : "neutral"}
                    size={21}
                    className={isActive ? "" : "opacity-55"}
                  />
                </span>
                <span
                  className={`text-[10px] font-medium ${
                    isActive ? "text-primary-700" : "text-foreground-400"
                  }`}
                >
                  {tab.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}